import { useEffect } from "react";

export default function TabControls({
  setCurrentTab,
  currentTabName,
  setCurrentTabName,
  tabOptions,
}) {
  const tabClasses =
    "data-[a=true]:text-gray-700 data-[a=true]:bg-gray-300 data-[a=false]:hover:text-gray-600 text-gray-500 font-semibold rounded-md px-2 py-1 transition";

  const setTabActive = (tabName) => {
    setCurrentTab(tabOptions[tabName]);
    setCurrentTabName(tabName);
  };

  return (
    <div className="flex flex-col gap-1 bg-gray-200 p-3 sticky top-0 z-10 w-full border-b border-b-gray-300 shadow">
      <div className="flex flex-row gap-2">
        <div className="block w-3 h-3 rounded-full bg-red-500 hover:bg-red-600 transition" />
        <div className="block w-3 h-3 rounded-full bg-yellow-500 hover:bg-yellow-600 transition" />
        <div className="block w-3 h-3 rounded-full bg-green-500 hover:bg-green-600 transition" />
      </div>
      <div className="flex flex-row overflow-x-scroll custom-no-scrollbar">
        {Object.keys(tabOptions).map((tab) => (
          <p
            key={`tab-${tab}`}
            data-a={currentTabName == tab}
            className={tabClasses}
            onClick={() => setTabActive(tab)}
          >
            {tab}
          </p>
        ))}
      </div>
    </div>
  );
}
